import type * as api from '@gitbook/api-client';
import * as analytics from '@gitbook/app-analytics/client';
import { Icon } from '@gitbook/spine-icons';

import { apiClient } from '../../../state';
import {
    QuickActionCard,
    QuickActionCardHeading,
    QuickActionCardIcon,
} from '../../Onboarding/cards';
import type { SpaceCreationOnCreateSpace } from './types';

interface DuplicateCardProps {
    space: api.Space;
    onCreateSpace: SpaceCreationOnCreateSpace;
}

export function DuplicateCard(props: DuplicateCardProps) {
    const { onCreateSpace, space } = props;
    return (
        <QuickActionCard
            onPress={async () => {
                await onCreateSpace(async () => {
                    const { data: duplicatedSpace } = await apiClient.spaces.duplicateSpace(
                        space.id
                    );
                    analytics.logEvent(
                        analytics.createSpaceEvent(duplicatedSpace, {
                            type: 'space_create',
                            source: 'duplicate',
                        })
                    );
                    return duplicatedSpace;
                });
            }}
        >
            <QuickActionCardIcon>
                <Icon.Copy />
            </QuickActionCardIcon>
            <QuickActionCardHeading>Duplicate content</QuickActionCardHeading>
        </QuickActionCard>
    );
}
